import { Row } from "@components/Layout";
import { Button } from "@kobalte/core";
import { styled } from "solid-styled-components";

export const PlayerControlsWrapper = styled(Row)`
  border-radius: 20px;
  position: relative;
`;
export const PlayerControlButton = styled(Button.Root)`
  width: 50%;
  height: 100%;
  color: ${({ theme }) => theme?.colors.accentTertiary};
  border: 1px solid ${({ theme }) => theme?.colors.accentTertiary}50;
  cursor: pointer;
  padding: 0 0 0 15px;
  display: flex;
  align-items: center;
  border-radius: 20px;
  background: none;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  &:last-of-type {
    justify-content: flex-end;
    padding: 0 16px 0 0;
  }
`;

export const PlayerControlPlayButtonWrapper = styled.div`
  position: absolute;
  left: 50%;
  translate: -50% -25%;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: ${({ theme }) => theme?.colors.foreground};
  z-index: 1;
`;
